import { StrictMode } from "react";

import { createRoot } from "react-dom/client";

import * as Sentry from "@sentry/react";

import App from "./app/App";

import "./shared/i18n";

import "./main.css";

// Error tracking (Sentry SDK → self-hosted GlitchTip, Sentry-compatible).

// Fully inert without a DSN: if VITE_SENTRY_DSN is unset (dev/CI), init never

// runs and the SDK captures nothing. See app/docs/sentry-selfhost-plan.md §3.3.

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    enableLogs: true,

    integrations: [
      Sentry.consoleLoggingIntegration({ levels: ["warn", "error"] }),

      Sentry.replayIntegration({
        maskAllText: true,

        maskAllInputs: true,

        blockAllMedia: true,
      }),
    ],

    replaysSessionSampleRate: 1.0,

    replaysOnErrorSampleRate: 1.0,

    dsn: import.meta.env.VITE_SENTRY_DSN,

    environment: import.meta.env.MODE,

    release: import.meta.env.VITE_SENTRY_RELEASE,

    tracesSampleRate: 0.1,

    sendDefaultPii: false,
  });
}

const container = document.getElementById("root");

if (!container) {
  throw new Error("Root element not found");
}

const root = createRoot(container);

root.render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Algo salió mal.</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
